module.exports = __webpack_public_path__ + "img/hero_s@2x.898988c0.webp";